// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"450":"17aa810d","512":"8f926e5d","597":"412f6d56","769":"9ac94f04"}[chunkId] + ".chunk.js";
};